var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',_vm._b({staticClass:"input-style",attrs:{"maxlength":_vm.maxLen,"placeholder":_vm.labelVal,"disabled":_vm.disabledType},domProps:{"value":_vm.value},on:{"keyup":_vm.onInput,"input":_vm.numberChk}},'input',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }